import React, { useEffect, useState } from "react";
import BtnPrimary from "../../../../../../../common/element/Buttons/btnPrimary";
import ImageUploader from "../../../../../../../common/element/ImageUploder";

const VisitorLog = (props) => {
  const maskUniqueEmail = (email) => {
    const e = (email || "").toString().trim();
    if (!e) return "-";
    const lower = e.toLowerCase();
    if (lower.includes("@unique")) return "-";
    return e;
  };

  return (
    <React.Fragment>
      <div className="flex w-full p-5 details-modal">
        <div className="col-1 h-75">
          <ImageUploader
            uploadImage={false}
            defaultImage={props?.detailsView?.visitor_image}
          />
        </div>
        <div className="pl-5 col-2">
          <form>
            <div className="w-full">
              <div className="mb-5">
                <label className="text-xs font-medium text-gray-700 mb-1.5 block">
                  Site contact
                </label>
                <input
                  disabled
                  value={
                    props?.detailsView?.visitorContact?.first_name
                      ? props?.detailsView?.visitorContact?.first_name +
                        " " +
                        props?.detailsView?.visitorContact?.last_name
                      : ""
                  }
                  type="text"
                  placeholder="Site contact name"
                  className="input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>
            <hr className="border-gray-200 mb-5" />
            <div className="flex w-full">
              <div className="flex-1 pr-1.5 mb-5">
                <label className="text-xs font-medium text-gray-700 mb-1.5 block">
                  First name*
                </label>
                <input
                  type="text"
                  disabled
                  value={props?.detailsView?.visitor_name.split(" ")[0]}
                  placeholder="Visitor’s first name"
                  className="input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="flex-1 pl-1.5 mb-5">
                <label className="text-xs font-medium text-gray-700 mb-1.5 block">
                  Last name*
                </label>
                <input
                  type="text"
                  disabled
                  value={props?.detailsView?.visitor_name.split(" ")[1]}
                  placeholder="Visitor’s last name"
                  className="input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>
            <div className="w-full">
              <div className="mb-5">
                <label className="text-xs font-medium text-gray-700 mb-1.5 block">
                  Email address*
                </label>
                <input
                  type="text"
                  disabled
                  value={maskUniqueEmail(props?.detailsView?.visitor_email)}
                  placeholder="Worker’s first name"
                  className="input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>
            <div className="w-full">
              <div className="mb-5">
                <label className="text-xs font-medium text-gray-700 mb-1.5 block">
                  Phone number
                </label>
                <input
                  type="text"
                  disabled
                  value={props?.detailsView?.visitor_phone}
                  placeholder="Visitor's phone number"
                  className="input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>
            <div className="w-full">
              <label className="text-xs font-medium text-gray-700 mb-1.5 block">
                Company name
              </label>
              <input
                type="text"
                disabled
                value={
                  props?.detailsView?.visitor_company
                    ? props?.detailsView?.visitor_company
                    : ""
                }
                placeholder="Visitor’s company name"
                className="input-shadow h-9 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
          </form>
        </div>
      </div>
      <div className="flex dailog-footer mt-0">
        <BtnPrimary className="ml-1.5" onClick={() => props.onDialogClose()}>
          Close
        </BtnPrimary>
      </div>
    </React.Fragment>
  );
};
export default VisitorLog;
